module.exports = (direction, field, exceptions, a, b) => {
  return direction === "ascending"
    ? exceptions.includes(field.toString())
      ? a[field].length - b[field].length
      : new Date(a[field]) - new Date(b[field])
    : exceptions.includes(field.toString())
    ? b[field].length - a[field].length
    : new Date(b[field]) - new Date(a[field]);
};
